export const raidMarkerTypes = [
  'circle',
  'cross',
  'diamond',
  'moon',
  'skull',
  'square',
  'star',
  'triangle',
] as const

export type RaidMarkerType = typeof raidMarkerTypes[number]
